import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import {useLeaflet} from 'react-leaflet';

const PolylineCluster = React.memo((props) => {

  const {
    getClusterIcon,
    useCluster,
    polylines,
    clusterIconColor
  } = props;

  const mcg = L.markerClusterGroup({
    iconCreateFunction: function () {
      return getClusterIcon(clusterIconColor);
    },
    maxClusterRadius: 50,
    showCoverageOnHover: false,
    disableClusteringAtZoom: useCluster ? 16 : 1,
    spiderfyOnMaxZoom: false
  });


  const {map} = useLeaflet();

  useEffect(() => {
    mcg.clearLayers();
    if (polylines) {
      polylines.forEach(pl => {
        new L.PolylineClusterable(pl.positions, {color: pl.color})
          .addTo(mcg);
      });
    }
    map.addLayer(mcg);
    return function cleanup() {
      map.removeLayer(mcg);
    }
  }, [mcg, map, polylines]);

  return null;
});

PolylineCluster.propTypes = {
  clusterIconColor: PropTypes.string,
  getClusterIcon: PropTypes.func.isRequired,
  useCluster: PropTypes.bool.isRequired,
  polylines: PropTypes.array.isRequired
};

export default PolylineCluster;
